import _SegmentationUtil from './../_SegmentationUtil';

export default [function () {
    return {
        restrict: 'EA',
        controller: ['$element', '$q', 'queryParamsData', function ($element, $q, queryParamsData) {
            return _SegmentationUtil($element, $q.resolve(queryParamsData));
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/queryparams/QueryParamsSegmentationDirective.js
// module id = 1076
// module chunks = 0